<div class="search-panel">
  <!-- RIGA FILTRI -->
  <div class="dsb-row search-panel__row">
    <ng-container *ngFor="let f of fields; trackBy: trackByFieldId">
      <ng-container *ngIf="isVisible(f)">
        <div class="dsb-col-3">
          <ng-container [ngSwitch]="f.type">
            <!-- TEXT -->
            <ds-input
              *ngSwitchCase="'text'"
              [inputLabel]="f.labelKey | translate"
              [inputName]="f.id"
              [inputId]="f.id"
              [inputValue]="(f.get(model) ?? '')"
              [inputPlaceholder]="(isDisabled(f) ? 'search.filterNotAvailable' : 'search.searchPlaceholder') | translate"
              [iconLeft]="'icon-search'"
              [isDisabled]="isDisabled(f)"
              [elementResetPair]="'search-panel-reset'"
              (onInputChange)="onDsInputChange(f, $event)"
            ></ds-input>

            <!-- SELECT -->
            <ds-select-list
              *ngSwitchCase="'select'"
              [selectId]="f.id"
              [menuId]="f.id"
              [menuLabel]="f.labelKey | translate"
              [menuPlaceholder]="(isDisabled(f) ? 'search.filterNotAvailable' : 'search.selectPlaceholder') | translate"
              [menuOptions]="translatedOptionsByFieldId[f.id] || []"
              [hasSearchbox]="f.hasSearchbox"
              [noResultsMessage]="'search.noResults' | translate"
              [isDisabled]="isDisabled(f)"
              [elementResetPair]="'search-panel-reset'"
              (onOptionSelection)="onDsSelectChange(f, $event)"
            ></ds-select-list>

            <!-- SELECT ALL -->
            <ds-select-checkbox
              *ngSwitchCase="'selectAll'"
              [selectId]="f.id"
              [hasSelectAll]="true"
              [selectAllLabel]="'search.selectAll' | translate"
              [menuPlaceholder]="(isDisabled(f) ? 'search.filterNotAvailable' : 'search.selectPlaceholder') | translate"
              [leftButtonLabel]="'search.cancel' | translate"
              [rightButtonLabel]="'search.confirmDate' | translate"
              [menuOptions]="getSelectCheckboxOptions(f.id)"
              [menuLabel]="f.labelKey | translate"
              [labelMultiOptionSelected]="'search.multiSelected' | translate"
              [labelSingleOptionSelected]="'search.singleSelected' | translate"
              [clickOutsideClosePanel]="true"
              [elementResetPair]="'search-panel-reset'"
              (onOpenSelect)="onDsSelectCheckboxOpen(f)"
              (onOptionSelection)="onDsSelectCheckboxOptionSelection(f, $event)"
              (onLeftButtonClick)="onDsSelectCheckboxLeftClick(f)"
              (onRightButtonClick)="onDsSelectCheckboxRightClick(f, $event)"
            ></ds-select-checkbox>

            <!-- DATE RANGE / SINGLE -->
            <ds-date-picker
              *ngSwitchCase="'dateRange'"
              [isDisabled]="isDisabled(f)"
              [isRangePicker]="f.isRangePicker !== false"
              [datepickerId]="f.id"
              [datePickerTitle]="f.labelKey | translate"
              [datePickerVariant]="'full-date'"
              [startingYear]="1990"
              [endingYear]="2030"
              [selectedValue]="(f.isRangePicker !== false) ? f.get(model)?.from : f.get(model)?.value"
              [secondSelectedValue]="(f.isRangePicker !== false) ? f.get(model)?.to : null"
              [datePickerstatus]="'default'"
              [language]="datePickerLanguage"
              [confirmButtonLabel]="'search.confirmDate' | translate"
              [prevMonthButtonAriaLabel]="'datePicker.prevMonth' | translate"
              [nextMonthButtonAriaLabel]="'datePicker.nextMonth' | translate"
              [monthSelectionAriaLabel]="'datePicker.monthSelection' | translate"
              [yearSelectionAriaLabel]="'datePicker.yearSelection' | translate"
              [resetButtonAriaLabel]="'datePicker.resetButton' | translate"
              [confirmButtonAriaLabel]="'datePicker.confirmButton' | translate"
              [elementResetPair]="'search-panel-reset'"
              (onDateSelection)="(f.isRangePicker !== false) ? onDsDateRangeChange(f, $event) : onDsDateChange(f, $event)"
            ></ds-date-picker>

            <!-- CHECKBOX -->
            <ds-checkbox
              *ngSwitchCase="'checkbox'"
              [checkboxId]="f.id"
              [checkboxLabel]="f.labelKey | translate"
              [checkboxAriaLabel]="f.labelKey | translate"
              [isChecked]="!!f.get(model)"
              [elementResetPair]="'search-panel-reset'"
              (onCheckboxChange)="onDsCheckboxChange(f, $event)"
            ></ds-checkbox>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>

    <!-- Bottoni nella stessa riga se l'ultima riga NON è piena -->
    <div *ngIf="!lastRowFull" class="search-panel__buttons-cell">
      <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
    </div>
  </div>

  <!-- FOOTER: chip sotto se bottoni inline, oppure chip + bottoni sulla stessa riga -->
  <ng-container *ngIf="!lastRowFull">
    <div *ngIf="chipsVisible && internalChips?.length" class="search-panel__footer-row">
      <ng-container *ngTemplateOutlet="chipsTemplate"></ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="lastRowFull">
    <div class="search-panel__footer-row search-panel__footer-row--combined">
      <div class="search-panel__footer-chips">
        <ng-container *ngIf="chipsVisible && internalChips?.length">
          <ng-container *ngTemplateOutlet="chipsTemplate"></ng-container>
        </ng-container>
      </div>
      <div class="search-panel__footer-actions">
        <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
      </div>
    </div>
  </ng-container>
</div>

<!-- TEMPLATE BOTTONI -->
<ng-template #buttonsTemplate>
  <div class="search-panel__actions">
    <ds-button
      [buttonType]="'reset'"
      [resetPair]="'search-panel-reset'"
      [buttonUIVariant]="'secondary'"
      [buttonSize]="'medium'"
      [buttonIcon]="'icon-reload'"
      [buttonAriaLabel]="'search.reset' | translate"
      [isDisabled]="false"
      (onCustomReset)="onClickReset()"
    ></ds-button>
    <ds-button
      [buttonType]="'button'"
      [buttonUIVariant]="'secondary'"
      [buttonSize]="'medium'"
      [buttonLabel]="'search.apply' | translate"
      [buttonAriaLabel]="'search.apply' | translate"
      [isDisabled]="false"
      (onClickEvent)="onClickSearch()"
    ></ds-button>
  </div>
</ng-template>

<!-- TEMPLATE CHIPS -->
<ng-template #chipsTemplate>
  <div class="filters-inline__chips">
    <ds-chips
      *ngFor="let chip of internalChips"
      [chipsText]="$any(chip).text"
      [chipsDisabled]="!!chip.disabled"
      [closeButton]="true"
      [closeButtonAriaLabel]="'Rimuovi filtro'"
      [attr.chip-size]="'medium'"
      (onCloseClick)="onChipRemove(chip.id)"
    ></ds-chips>
  </div>
</ng-template>
